"use strict";;define(function(require,exports,module){const _   = require('lodash');
const Vue = require('vue');

/**
 * This is a hack to register a dependency on `validationEnabledVueHack`
 * Apparently directives only register dependencies on things touched as a part of computing the directive value.
 * They do not register dependencies on observables that are touched inside the directive itself
 * @param  {Object} options - pass-through to the directive
 * @return {Object}
 */
Vue.util.validationHelper = function(options) {
	if (_.get(options, 'model.validationEnabledVueHack')) {
		options.model.validationEnabledVueHack.dummy;
	}
	return options;
};

});